import { types } from 'mobx-state-tree';
import { RequestStateModel } from 'store/models/general-models';

export const StatusesModel = types.model('AppealsStatusesModel', {
  list: types.optional(RequestStateModel, {}),
  stats: types.optional(RequestStateModel, {}),
  history: types.optional(RequestStateModel, {}),
  categories: types.optional(RequestStateModel, {}),
  getAppeal: types.optional(RequestStateModel, {}),
  deleteAppeal: types.optional(RequestStateModel, {}),
  getComments: types.optional(RequestStateModel, {}),
  createCategory: types.optional(RequestStateModel, {}),
  topicsList: types.optional(RequestStateModel, {}),
  otherPersons: types.optional(RequestStateModel, {}),
  xlsxReport: types.optional(RequestStateModel, {}),
  getOurSpbAvailability: types.optional(RequestStateModel, {}),
  getAppealsWithSameProblem: types.optional(RequestStateModel, {}),
});
